import { render, staticRenderFns } from "./PesquisaRecomendacao.vue?vue&type=template&id=765a9bbd&scoped=true"
import script from "./PesquisaRecomendacao.vue?vue&type=script&lang=js"
export * from "./PesquisaRecomendacao.vue?vue&type=script&lang=js"
import style0 from "./PesquisaRecomendacao.vue?vue&type=style&index=0&id=765a9bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a9bbd",
  null
  
)

export default component.exports